import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { createConsumer } from "@rails/actioncable";
import { ApiMessage } from "~/types/devices";
export default class extends Controller {
	mac_address!: string;
	connection: any;
	private interval?: number;

	static targets = ["screen", "image", "video"];

	declare readonly screenTarget: HTMLElement;
	declare readonly imageTarget: HTMLImageElement;
	declare readonly videoTarget: HTMLVideoElement;

	connect() {
		const controller = this;
		const el = this.element as HTMLDivElement;
		this.mac_address = el.dataset.macaddress!;
		console.log(this.mac_address);


		// setup ActionCable subscription
		const consumer = createConsumer();
		this.connection = consumer.subscriptions.create(
			{ channel: 'DeviceIfChannel', mac: this.mac_address },
			{
				connected: () => {
					console.log("connected");
					this.interval = setInterval(() => {
						(consumer as any).connection.send("pong");
					}, 3000);
				},
				disconnected: () => {
					console.log("disconnected");
					if (this.interval) {
						clearInterval(this.interval);
					}
				},
				received: (data: ApiMessage) => {
					console.log(data);
					if ("data" in data) {
						this.command(data.data);
					}
				},
			}
		);
	}

	private command(data: string): void {
		console.log(data);
		switch (data) {
			case '1':
				this.render("https://picsum.photos/id/16/3840/2160");
				break;
			case '2':
				this.render("https://samplelib.com/mp4/sample-5s.mp4");
				break;
		}
	}

	public render(data: string): void {
		this.reset();

		if (this.isVideo(data)) {
			this.showVideo(data);
		} else {
			this.showImage(data);
		}
	}

	private showImage(url: string): void {
		const img = this.imageTarget;

		img.src = url;
		img.classList.add("is-visible");

		img.onload = async () => {
			await this.enterFullscreen();
		};
	}

	private showVideo(url: string): void {
		const video = this.videoTarget;

		video.src = url;
		video.classList.add("is-visible");

		video.play().catch(() => {
			console.warn("Autoplay blocked");
		});

		video.onloadeddata = async () => {
			await this.enterFullscreen();
		};
	}

	private reset(): void {
		const img = this.imageTarget;
		const video = this.videoTarget;

		img.classList.remove("is-visible");
		video.classList.remove("is-visible");

		img.src = "";
		video.pause();
		video.src = "";
	}

	private isVideo(url: string): boolean {
		return url.match(/\.(mp4|webm|ogg)(\?.*)?$/i) !== null;
	}

	private async enterFullscreen(): Promise<void> {
		if (!document.fullscreenElement) {
			try {
				await this.screenTarget.requestFullscreen();
			} catch (e) {
				console.warn("Fullscreen blocked", e);
			}
		}
	}


}